import { WidgetTranslationKey } from '@/resources/widget-translations';
import { ShapeBaseAttribute } from './base';

export class WidgetAttribute extends ShapeBaseAttribute {
  /**
   * row：横向布局，column：纵向布局， disabled: 禁止自动布局。该属性不存在或值为disabled时，禁用自动布局
   *
   * @type {('row' | 'column' | 'disabled')}
   * @memberof WidgetAttribute
   */
  flexDirection: 'row' | 'column' | 'disabled' = 'disabled';

  /**
   *主轴布局
   *
   * @type {('flex-start' | 'flex-end' | 'center')}
   * @memberof WidgetAttribute
   */
  justifyContent: 'flex-start' | 'flex-end' | 'center' = 'flex-start';

  /**
   * 交叉轴布局
   *
   * @type {('flex-start' | 'flex-end' | 'center')}
   * @memberof WidgetAttribute
   */
  // alignContent: 'flex-start' | 'flex-end' | 'center' = 'flex-start';
  alignItems: 'flex-start' | 'flex-end' | 'center' = 'flex-start';

  /**
   * 元素间距
   *
   * @memberof WidgetAttribute
   */
  gap = 0;

  /**
   * 跳转app
   *
   * @memberof WidgetAttribute
   */
  jumpApp?: string;

  /**
   * 运动类型id
   *
   * @memberof WidgetAttribute
   */
  jumpAppSportTypeId?: number;
  /**
   * 具体运动id
   *
   * @memberof WidgetAttribute
   */
  jumpAppSportId?: number;
  /**
   * 自定义跳转应用名称
   *
   * @memberof WidgetAttribute
   */
  jumpAppCustomName?: string;

  /**
   * 支付宝支付内容
   * openApp: 打开应用, paymentCode: 付款码, tapPay: 碰一下
   *
   * @memberof WidgetAttribute
   */
  jumpAppAlipayContent?: string;

  /**
   * 多语言时需要指定widgetName
   *
   * @memberof WidgetAttribute
   */
  widgetName = '';

  /**
   * widget关联的数据项
   *
   * @type {string}
   * @memberof WidgetAttribute
   */
  relatedDataKey?: WidgetTranslationKey;

  resources: {
    /**
     * widget预览图
     */
    widgetPreview?: LayerResourceItem;
    editBox?: LayerResourceItem;
  } = {};

  /** 点击最小区域展示 */
  minClickZone = false;

  /** 条件切换动效：每个条件对应一个子 Widget，最后一个子 Widget 作为 else */
  widgetConditions?: Condition[];

  /** 条件切换动效的动画过程 */
  widgetAnimations?: IAnimation[];
}
